import * as React from 'react';
import './MobileFooter.css';
import { Link, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { getUserProfile } from '../../../store/user/selectors';
import cn from 'classnames';
import BookIcon from '@material-ui/icons/BookOutlined';
import DateRange from '@material-ui/icons/DateRange';
import ProfileIcon from '@material-ui/icons/AccountCircleOutlined';
import Feed from '@material-ui/icons/Explore';
import Home from '@material-ui/icons/Home';

const MobileFooter: React.FunctionComponent = props => {
	const user = useSelector(getUserProfile);
	const path = useLocation();

	const isUser = user && user.id >= 0;

	return (
		<div className="mobileFooter__wrapper">
			<div
				onClick={() => (window.location.href = "/")}
				className={cn("mobileFooter__item", {
					selected: path.pathname === "/",
				})}
			>
				<div className={cn("mobileFooter__icon", "mobileFooter__icon_home")} />
			</div>

			<div
				onClick={() => (window.location.href = "/books")}
				className={cn("mobileFooter__item", {
					selected: path.pathname.includes("/books"),
				})}
			>
				<div className={cn("mobileFooter__icon", "mobileFooter__icon_books")} />
			</div>

			{/*<div
				onClick={() => (window.location.href = "/list")}
				className={cn("mobileFooter__item", {
					selected: path.pathname.includes("/list"),
				})}
			>
				<p>
					<Feed />
				</p>{" "}
				Обзор
			</div>*/}

			<div
				onClick={() => (window.location.href = "/calendar")}
				className={cn("mobileFooter__item", {
					selected: path.pathname.includes("/calendar"),
				})}
			>
				<div
					className={cn("mobileFooter__icon", "mobileFooter__icon_calendar")}
				/>
			</div>

			<div
				onClick={() =>
					(window.location.href = isUser ? `/user/${user.id}` : "/login")
				}
				className={cn("mobileFooter__item", {
					selected: path.pathname.includes("/user/"),
				})}
			>
				<div className={cn("mobileFooter__icon", "mobileFooter__icon_stat")} />
			</div>

			{/*user && user.id >= 0 ? (
				<div
					onClick={() => (window.location.href = `/profile/#/${user.id}`)}
					className={cn("mobileFooter__item", {
						selected: path.pathname.includes("/profile"),
					})}
				>
					<p>
						<ProfileIcon />
					</p>{" "}
					Профиль
				</div>
			) : (
				<div
					onClick={() => (window.location.href = "/login")}
					className={cn("mobileFooter__item", {
						selected: path.pathname.includes("/login"),
					})}
				>
					<p>
						<ProfileIcon />
					</p>{" "}
					Войти
				</div>
				)*/}
		</div>
	);
};

export default MobileFooter;
